import {Directive, PLATFORM_ID, inject, input} from '@angular/core';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';

/**
 * While its value is true, the browser asks before the page is closed or reloaded (its own
 * "Leave site?" prompt; the wording can't be changed). The listener is only attached while
 * needed: a beforeunload listener keeps the page out of the back/forward cache.
 */
@Directive({
  standalone: true,
  selector: '[plWarnBeforeUnload]',
})
export class WarnBeforeUnloadDirective {
  readonly warn = input(false, {alias: 'plWarnBeforeUnload'});

  private readonly _window = isPlatformBrowser(inject(PLATFORM_ID))
    ? inject(DOCUMENT).defaultView
    : null;

  constructor() {
    const win = this._window;
    if (!win) {
      return;
    }
    const onBeforeUnload = (event: BeforeUnloadEvent) => event.preventDefault();
    toObservable(this.warn)
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (warn) =>
          warn
            ? win.addEventListener('beforeunload', onBeforeUnload)
            : win.removeEventListener('beforeunload', onBeforeUnload),
        complete: () => win.removeEventListener('beforeunload', onBeforeUnload),
      });
  }
}
